<template>
  <div class="cta-caja cta-caja--yellow" @click="clicking">
    <div class="cta-caja__cover">
      <img
        class="cta-caja__cover-desk"
        src="../../../assets/img/covers/cover-cta-caja-yellow.jpg"
        alt=""
      />
      <img
        class="cta-caja__cover-mobile"
        src="../../../assets/img/covers/cover-cta-caja-yellow-m.jpg"
        alt=""
      />
    </div>
    <div class="cta-caja__content">
      <h4 class="cta-caja__title">¡La caja regalo HelloBB más educativa!</h4>
      <div class="cta-caja__description">
        <p>Ideal para vuestros primeros ratos contando historias.</p>
      </div>
      <div class="cta-caja__actions">
        <loading-button v-if="loading" :class="'button-loading--sm'" />
        <button
          v-else
          class="button button--accent button--sm button--ico"
          @click.stop="addProduct('Constructor - Banner Horitzontal')"
          :disabled="added"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
    <modal-dialog
        :show="showProductAddedDialog"
        @close="showProductAddedDialog = false"
        target-class="modal__card--mini"
    >
      <product-added-to-list/>
    </modal-dialog>
  </div>
</template>

<script>
import Product from "./Mixins/Product";
import LoadingButton from "../../../components/LoadingButton";
import ModalDialog from "../../../components/ui/ModalDialog";
import ProductAddedToList from "../../../components/ProductAddedToList";

export default {
  name: "CtaChildrenStories",
  mixins: [Product],
  components: {
    LoadingButton,
    ModalDialog,
    ProductAddedToList
  },
  computed: {
    buttonText() {
      return this.added ? "Añadido" : "Añadir a mi lista";
    },
  },
  created() {
    this.product = {
      id: 41821,
      name: "Vuestros primeros cuentos - Caja de regalo HelloBB",
      "brand-slug": "caja-regalo-hellobb-primeros-cuentos",
      retailerName: "HelloBB",
      productRetailers: [{"name": "HelloBB"}]
    };
  },
  methods: {
    clicking()
    {
      mixpanel.track("Click element constructor", {
        "Name": "Vuestros primeros cuentos - Caja de regalo HelloBB",
        "Section": "Secció inicial",
        "Section number": 0,
        "Type": "Banner - Horizontal",
        "Content": "Ecommerce"
      });
      this.browseProduct();
    }
  }
};
</script>
